export const GET_PRODUCTS_SUCCES = 'GET_PRODUCTS_SUCCES'
export const GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE'

export const GET_PRODUCTS_BY_INCREASE_MANUFACTURER = "GET_PRODUCTS_BY_INCREASE_MANUFACTURER"
export const GET_PRODUCTS_BY_DECREASE_MANUFACTURER = "GET_PRODUCTS_BY_DECREASE_MANUFACTURER"

export const GET_PRODUCTS_BY_MAX_PRICE = 'GET_PRODUCTS_BY_MAX_PRICE'
export const GET_PRODUCTS_BY_MIN_PRICE = 'GET_PRODUCTS_BY_MIN_PRICE'